import { Button as AntButton, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  useGetCopyBookSeqCheckListQuery,
  useSaveCopyBookMutation,
} from '../../../api/books/bookManagement.api';
import { useSnackbar } from 'notistack';
import { successVariant } from '../../../lib/barVariant';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  onCancel: () => void;
  titleText: string;
  confirmText: string;
  cancelText?: string;
  campusCode: string;
  bookNo: number;
}

const CopyBookRegisterModal = ({
  visible,
  onCancel,
  confirmText,
  cancelText,
  titleText,
  campusCode,
  bookNo,
}: IProps) => {
  const { t } = useTranslation();
  const options = Array.from({ length: 10 }, (v, i) => i + 1);
  const { data: response } = useGetCopyBookSeqCheckListQuery({
    campusCode,
    bookNo,
  });
  const checkNumbers = response?.data;
  const [copyBookRegisterTrigger, { isLoading, isSuccess }] =
    useSaveCopyBookMutation();
  const [bookSeq, setBookSeq] = useState<number | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const handleCopyBookSave = () => {
    copyBookRegisterTrigger({ bookNo, bookSeq, campusCode });
  };

  useEffect(() => {
    if (checkNumbers) {
      setBookSeq(
        Math.min.apply(
          null,
          options.filter(
            (number) => !checkNumbers?.find((num: number) => number === num),
          ),
        ),
      );
    }
  }, [checkNumbers]);

  useEffect(() => {
    if (!isSuccess) return;

    enqueueSnackbar(t('books.text.1'), successVariant);
    onCancel();
  }, [isSuccess]);

  const getFooter = () => {
    return [
      <div className='comm-btn__area justify-content-center'>	
        <AntButton
          key="submit"
          className='btn-basic pink'
          loading={isLoading}
          onClick={handleCopyBookSave}
        >
          {confirmText}
        </AntButton>
        <AntButton key="cancel" onClick={onCancel} className='btn-basic gray'>
          {cancelText}
        </AntButton>
      </div>
    ];
  };

  return (
    <Modal
      visible={visible}
      title={titleText}
      onCancel={onCancel}
      width={300}
      footer={getFooter()}
    >
      <div className="flex justify-content-center mb-2">
        {t('books.text.2')}
      </div>
      <div className="flex justify-content-center mb-2">
        <Select
          className="w-100p"
          value={bookSeq}
          onChange={(value: number) => setBookSeq(value)}
        >
          {options.map((value) => {
            const findNumber = checkNumbers?.find(
              (number: number) => number === value,
            );
            return (
              <Select.Option key={value} value={value} disabled={findNumber}>
                {value}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </Modal>
  );
};

export default CopyBookRegisterModal;
